import React, { createContext, useContext, useState, ReactNode } from 'react';

export type FontSizeValue = 'default' | 'large' | 'x-large' | string;

export interface FontSizeContextValue {
    fontSize: FontSizeValue;
    setFontSize: (newFontSize: FontSizeValue) => void;
}

const FontSizeContext = createContext<FontSizeContextValue>({
    fontSize: 'default',
    setFontSize: () => {},
});

export const useFontSize = (): FontSizeContextValue => useContext(FontSizeContext);

interface FontSizeProviderProps {
    children: ReactNode;
}

export const FontSizeProvider = ({ children }: FontSizeProviderProps) => {
    const [fontSize, setFontSize] = useState<FontSizeValue>('default');

    const handleFontSizeChange = (newFontSize: FontSizeValue): void => {
        setFontSize(newFontSize);
    };

    return (
        <FontSizeContext.Provider value={{ fontSize, setFontSize: handleFontSizeChange }}>
            {children}
        </FontSizeContext.Provider>
    );
};
